export default function SafetySection() {
  const risks = [
    {
      risk: 'Fake Websites',
      protection: 'Always use official domains and verified links from trusted sources',
    },
    {
      risk: 'Payment Risks',
      protection: 'Use secure payment methods and avoid sharing sensitive financial details',
    },
    {
      risk: 'Wrong Information',
      protection: 'Cross-check product details against multiple verified resources before purchasing',
    },
    {
      risk: 'Privacy Concerns',
      protection: 'Never share passwords or personal information with unverified third parties',
    },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-5/12">
            <p className="text-xs font-label tracking-widest uppercase text-accent-600 mb-4">
              / Safety &amp; Trust
            </p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Is Hipobuy Spreadsheet Safe?
            </h2>
            <p className="text-base text-foreground-600 mt-4 leading-relaxed">
              Safety is our top priority. We have created this guide to help you navigate the online shopping landscape securely, avoid common pitfalls, and protect your personal information while discovering products through spreadsheet resources.
            </p>
            <p className="text-base text-foreground-600 mt-3 leading-relaxed">
              Understanding how to identify legitimate resources from potentially misleading ones is essential. The following checklist highlights key risks and the corresponding protections you should always keep in mind.
            </p>
          </div>

          <div className="lg:w-7/12">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {risks.map((item) => (
                <div
                  key={item.risk}
                  className="bg-background-50 border border-background-200/60 rounded-lg p-5"
                >
                  <p className="text-sm font-heading font-semibold text-foreground-900 mb-2">
                    {item.risk}
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.protection}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}